/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OutputFormatDTO } from '../models/OutputFormatDTO';
import type { OutputFormatDTOODataListResponse } from '../models/OutputFormatDTOODataListResponse';
import type { OutputFormatEditDTO } from '../models/OutputFormatEditDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class OutputFormatService {

    /**
     * @param clientId 
     * @param top The max number of records.
     * @param skip The number of records to skip.
     * @param filter A function that must evaluate to true for a record to be returned.
     * @param select Specifies a subset of properties to return. Use a comma separated list.
     * @param orderby Determines what values are used to order a collection of records.
     * @param expand Use to add related query data.
     * @param count Include the overall count
     * @returns OutputFormatDTOODataListResponse Success
     * @throws ApiError
     */
    public static getBackendv2Outputformat(
clientId?: number,
top?: string,
skip?: string,
filter?: string,
select?: string,
orderby?: string,
expand?: string,
count?: string,
): CancelablePromise<OutputFormatDTOODataListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/backendv2/outputformat',
            query: {
                'clientId': clientId,
                '$top': top,
                '$skip': skip,
                '$filter': filter,
                '$select': select,
                '$orderby': orderby,
                '$expand': expand,
                '$count': count,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns OutputFormatDTO Success
     * @throws ApiError
     */
    public static postBackendv2Outputformat(
requestBody?: OutputFormatEditDTO,
): CancelablePromise<OutputFormatDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/backendv2/outputformat',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param key 
     * @returns OutputFormatDTO Success
     * @throws ApiError
     */
    public static getBackendv2Outputformat1(
key: number,
): CancelablePromise<OutputFormatDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/backendv2/outputformat/{key}',
            path: {
                'key': key,
            },
        });
    }

    /**
     * @param key 
     * @param requestBody 
     * @returns OutputFormatDTO Success
     * @throws ApiError
     */
    public static putBackendv2Outputformat(
key: number,
requestBody?: OutputFormatEditDTO,
): CancelablePromise<OutputFormatDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/backendv2/outputformat/{key}',
            path: {
                'key': key,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param key 
     * @returns any Success
     * @throws ApiError
     */
    public static deleteBackendv2Outputformat(
key: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/backendv2/outputformat/{key}',
            path: {
                'key': key,
            },
        });
    }

}
